/**
 * An exact duplicate of: https://github.com/lluvio/vue-logger I'm using my own
 * so it runs through my build process and shims the usage of Array.from,
 * because IE does not support Array.from. Just using the dist version from the
 * lib causes errors in IE
 *
 * UPDATE: package maintainer has updated this, but not yet released. fyi...
 */
export default {
  install (Vue, options) {
    if (this.installed) return
    const logger = {
      dev: true,
      prefix: '',
      shortname: true,
      levels: ['log', 'warn', 'debug', 'error', 'dir', 'info']
    }
    if (options) {
      for (const key of Object.keys(options)) {
        if (key === 'levels') {
          logger[key] = logger[key].concat(options[key])
        } else {
          logger[key] = options[key]
        }
      }
    }
    for (const level of logger.levels) {
      logger[level] = function () {
        if (!logger.dev || typeof console === 'undefined') return
        const args = Array.from(arguments)
        args.unshift(`[${logger.prefix} :: ${level}]`.toUpperCase())
        console[level].apply(console, args)
      }
      if (logger.shortname) {
        Vue.prototype[`$${level}`] = logger[level]
      }
    }
    Vue.prototype.$console = logger
    Vue.console = logger
  }
}



// WEBPACK FOOTER //
// ./src/frontend/util/logger.js